import EnumSet from 'Services/enumSet'

export interface ISubscriptionErrorTypes extends EnumSet {
  generic: number
  signup: number
  upgrade: number
}

const SubscriptionErrorTypes = new EnumSet({
  generic: { value: 0, description: 'Erro não identificado no processo de checkout' },
  signup: { value: 1, description: 'Erro no checkout de empresa recém cadastrada' },
  upgrade: { value: 2, description: 'Erro no checkout de upgrade plano' },
}) as ISubscriptionErrorTypes

export default SubscriptionErrorTypes